import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { Order } from '../Order'
import { Field, ID, InputType } from 'type-graphql'

/**
 * Args for marking an order as "Not Receivable" (uncollectible) or reverting it.
 * value=true pins paymentStatus to "Not Receivable" and records `reason` as an
 * order remarks activity. value=false re-derives paymentStatus from payments/net.
 */
@InputType()
export class MarkOrderNotReceivableArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string

  @Field(() => Boolean)
  value: boolean

  @Field(() => String, { nullable: true })
  reason?: string
}

export interface IMarkOrderNotReceivable extends IAction<Order, MarkOrderNotReceivableArgs> {}
